export function getSamlBaseUrl(): string {
  // Always use SAML_BASE_URL if provided, otherwise fall back to NEXT_PUBLIC_APP_URL
  let baseUrl = process.env.SAML_BASE_URL || process.env.NEXT_PUBLIC_APP_URL || 'https://chat.vectorize.io';
  
  // Clean up the URL - remove any duplicate protocols
  baseUrl = baseUrl.replace(/^https?:\/\/https?:\/\//, 'https://');
  
  // Ensure the URL has a proper protocol
  if (!baseUrl.startsWith('http://') && !baseUrl.startsWith('https://')) {
    return `https://${baseUrl}`;
  }
  
  // Remove any trailing slashes
  return baseUrl.replace(/\/$/, '');
}

export function getSamlCallbackUrl(agentId: string): string {
  return `${getSamlBaseUrl()}/api/chat/agents/${agentId}/saml/callback`;
}

export function getSamlEntityId(agentId: string): string {
  // Use a consistent entity ID format with the base URL
  const baseUrl = getSamlBaseUrl();
  return `${baseUrl}/agent/${agentId}`;
}